import { render, staticRenderFns } from "./MarketNews.vue?vue&type=template&id=6bdfe6a6&scoped=true"
import script from "./MarketNews.vue?vue&type=script&lang=js"
export * from "./MarketNews.vue?vue&type=script&lang=js"
import style0 from "./MarketNews.vue?vue&type=style&index=0&id=6bdfe6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdfe6a6",
  null
  
)

export default component.exports